<div
  class="answer-tile"
  [class.selected]="isSelected"
  (click)="toggleSelection()"
  >
  {{ answerText }}
  @if (isSelected) {
    <span class="checkmark">&#10003;</span>
  }
</div>